import { useTranslation } from 'react-i18next';
import { YoutubeAnalyticsPostPayloads } from '@anytag/graphql';
import { getYoutubePostUrl, getYoutubeVideoUrl } from '@anytag/shared-utils';
import { PostModal } from '../shared';

export interface YoutubePostInDateDetailsModalProps {
  paramKey?: string;
  data: YoutubeAnalyticsPostPayloads | null;
}
export const YoutubePostInDateDetailsModal = ({ data, paramKey }: YoutubePostInDateDetailsModalProps) => {
  const { t } = useTranslation();

  return (
    <PostModal posts={data?.posts || []} paramKey={paramKey}>
      {({ selectedPost }) => (
        <>
          <PostModal.Title>{t('Post Detail')}</PostModal.Title>
          <PostModal.DetailsTemplate
            data={{
              socialMedia: 'YOUTUBE',
              postDate: selectedPost.postDate,
              caption: selectedPost.videoCaption,
              postUrl: getYoutubePostUrl(selectedPost.videoId),
              video: { title: selectedPost.videoTitle, url: getYoutubeVideoUrl(selectedPost.videoId) },
              comments:
                selectedPost.videoComments.map((comment) => ({
                  content: comment.content,
                  username: comment.posterName
                })) || [],
              info: {
                avatar: data?.avatar,
                name: data?.channelName,
                followers: selectedPost.subscribers
              },
              statistics: {
                views: selectedPost.views,
                averageViewDuration: selectedPost.averageViewDuration,
                averageViewPercentage: selectedPost.averageViewPercentage,
                likes: selectedPost.likes,
                dislikes: selectedPost.dislikes,
                comments: selectedPost.comments
              }
            }}
          />
        </>
      )}
    </PostModal>
  );
};
